import {
  combine,
  withMemo,
  withContext,
  withCallback,
} from 'react-hooks-combine'
import { ServicesContext } from 'services/context'

import { createColumns } from './columns.description'
import MembersComponent from './component'

export const Members = combine(
  withContext(
    'adminMemberService',
    ServicesContext,
    ({ adminMemberService }) => adminMemberService
  ),
  withMemo('columns', () => createColumns(), []),
  withCallback(
    'loadMembers',
    ({ adminMemberService }) =>
      (tableState) => {
        return adminMemberService.queryMembers({
          page: tableState.page,
          size: tableState.pageSize,
        })
      },
    []
  )
)(MembersComponent)
